import PropTypes from 'prop-types';

export const mobileDrawerPropTypes = {
  /**
   * An array of category objects for the mobile drawer.
   * Each category object must include a `name` and can optionally include submenus.
   * Example:
   * [
   *   {
   *     name: "Category 1",
   *     submenus: [
   *       {
   *         name: "Submenu 1-1",
   *         submenus: [],
   *         bold: true,
   *         bluecolor: false,
   *         isClickable: true,
   *       }
   *     ]
   *   }
   * ]
   */
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The name of the category to be displayed.
       */
      name: PropTypes.string.isRequired,
      /**
       * An array of submenu objects under the category.
       * Each submenu object may contain nested submenus and various display properties.
       */
      submenus: PropTypes.arrayOf(
        PropTypes.shape({
          /**
           * The name of the submenu to be displayed.
           */
          name: PropTypes.string.isRequired,
          /**
           * An array of nested submenu objects.
           */
          submenus: PropTypes.array,
          /**
           * If true, the submenu text will be displayed in bold.
           */
          bold: PropTypes.bool,
          /**
           * If true, the submenu text will be colored blue.
           */
          bluecolor: PropTypes.bool,
          /**
           * If true, the submenu will be clickable.
           */
          isClickable: PropTypes.bool,
        }),
      ),
    }),
  ).isRequired,

  /**
   * The width of the mobile drawer.
   * Can be specified as a string (e.g., '250px') or a number (interpreted as pixels).
   */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Controls whether the drawer is open or closed.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Function to call when the drawer is closed.
   */
  onClose: PropTypes.func.isRequired,
};

/**
 * Default props for the MobileDrawer component.
 */
export const mobileDrawerDefaultProps = {
  width: '250px',
};
